import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-origem-input-group',
    templateUrl: './origem-input-group.component.html',
    styleUrls: ['./origem-input-group.component.less']
})
export class OrigemInputGroupComponent {
    /** Origem */
    @Input() origem: number;
}
